import React, { useContext, useEffect, useState } from "react";
import { Card, Col, FormGroup, Row } from "reactstrap";
import { getUsersApi } from "../Users/Api/GetUsers";
import { UserActivityContext } from "./ContextProvider";

const ListHeader = () => {
  const { filters, setFilters } = useContext(UserActivityContext);
  const [users, setUsers] = useState([]);
  const fetchUsers = async () => {
    let response = await getUsersApi();
    if (response.result === "success") {
      setUsers(response.data?.items);
    }
  };
  useEffect(() => {
    fetchUsers();
  }, []);

  const handleUserChange = async (e) => {
    let value = e.target.value;

    setFilters({
      ...filters,
      ...{ user_id: value },
    });
  };
  const handleEvbentTypeChange = async (e) => {
    let value = e.target.value;

    setFilters({
      ...filters,
      ...{ event: value },
    });
  };

  const handleFromChange = async (e) => {
    let value = e.target.value;

    setFilters({
      ...filters,
      ...{ date_from: value },
    });
  };
  const handleToChange = async (e) => {
    let value = e.target.value;

    setFilters({
      ...filters,
      ...{ date_to: value },
    });
  };
  return (
    <>
      <Card className="p-3">
        <Row>
          <Col xl="3" className="xl-30 box-col-30">
            <FormGroup>
              <select
                id="exampleFormControlSelect3"
                className={`form-select `}
                onChange={handleUserChange}
              >
                <option value={""} selected>
                  Todos los usuarios...
                </option>
                {users.map((option) => (
                  <option key={option.id} value={option.id}>
                    {option.first_name} {option.last_name}
                  </option>
                ))}
              </select>
            </FormGroup>
          </Col>
          <Col xl="3" className="xl-30 box-col-30">
            <FormGroup>
              <select
                id="envent_type"
                className={`form-select `}
                onChange={handleEvbentTypeChange}
              >
                <option value={""} selected>
                  Tipo de operacion...
                </option>

                <option value={"retrieved"}>VISUALIZACION</option>
                <option value={"deleted"}>ELIMINACION</option>
                <option value={"updated"}>ACTUALIZACON</option>
                <option value={"created"}>CREACION</option>
                <option value={"restored"}>RESTAURACION</option>
              </select>
            </FormGroup>
          </Col>
          <Col sm="2">
            <input
              onChange={handleFromChange}
              className={`form-control `}
              type="date"
              placeholder="Desde..."
              autoComplete="off"
            />
          </Col>
          <Col sm="2">
            <input
              onChange={handleToChange}
              className={`form-control digits `}
              type="date"
              placeholder="Hasta..."
              autoComplete="off"
            />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default ListHeader;
